import { Form } from 'antd'
import { ReactNode } from 'react'
import { NO_DATA_PLACEHOLDER } from '../../constants/constants'
import FormContentContainer from './FormContentContainer'

type ReadOnlyFormFieldProps = {
  label: string
  children?: ReactNode
  placeholder?: ReactNode
}

const ReadOnlyFormField = ({
  label,
  children,
  placeholder = NO_DATA_PLACEHOLDER,
}: ReadOnlyFormFieldProps) => (
  <Form.Item label={label}>
    <FormContentContainer>{children ?? placeholder}</FormContentContainer>
  </Form.Item>
)

export default ReadOnlyFormField
